export default __webpack_public_path__ + "static/media/Untitled-1.1869f3bd.png";